import React from 'react';

const ArchiveIcon: React.FC = () => (
  <svg width="20" height="20" viewBox="0 0 20 20" fill="none" xmlns="http://www.w3.org/2000/svg">
    <path
      opacity="0.4"
      d="M14.0176 1.6665H5.98424C4.20924 1.6665 2.76758 3.1165 2.76758 4.88317V16.6248C2.76758 18.1248 3.84258 18.7582 5.15924 18.0332L9.22591 15.7748C9.65924 15.5332 10.3592 15.5332 10.7842 15.7748L14.8509 18.0332C16.1676 18.7665 17.2426 18.1332 17.2426 16.6248V4.88317C17.2342 3.1165 15.7926 1.6665 14.0176 1.6665Z"
      fill="#12B76A"
    />
    <path
      d="M10.0006 8.56647C9.15061 8.56647 8.30061 8.41647 7.49228 8.1248C7.16728 8.00813 7.00061 7.6498 7.11728 7.3248C7.24228 6.9998 7.60061 6.83313 7.92561 6.9498C9.26728 7.43313 10.7423 7.43313 12.0839 6.9498C12.4089 6.83313 12.7673 6.9998 12.8839 7.3248C13.0006 7.6498 12.8339 8.00813 12.5089 8.1248C11.7006 8.41647 10.8506 8.56647 10.0006 8.56647Z"
      fill="#12B76A"
    />
  </svg>
);

export default ArchiveIcon;
